import { BarChart2, LineChart, Table, List } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DataToggle = ({ active, onChange, showMonthly = true }) => {
    const { t } = useTranslation('common');

    const toggleOptions = [
        { id: 'overview', label: t('overview'), icon: <BarChart2 className="w-4 h-4" /> },
        { id: 'graph', label: t('graph'), icon: <LineChart className="w-4 h-4" /> },
        { id: 'monthly', label: t('monthly'), icon: <Table className="w-4 h-4" /> },
        { id: 'raw', label: t('raw'), icon: <List className="w-4 h-4" /> },
    ];

    const visibleOptions = toggleOptions.filter(
        (option) => showMonthly || option.id !== 'monthly'
    );

    return (
        <div className="inline-flex rounded-xl bg-gray-175 border border-gray-200 p-1">
            {visibleOptions.map((option) => {
                const isActive = active === option.id;
                return (
                    <button
                        key={option.id}
                        onClick={() => onChange(option.id)}
                        className={`flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg transition-all
              ${isActive ? 'bg-white text-black shadow-sm' : 'text-gray-500 hover:text-black'}`}
                    >
                        {option.icon}
                        <span>{option.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default DataToggle;